'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _app = require('./app.html');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _app2.default,
  bindings: {
    flex: '@',
    layout: '@',
    currentUser: '<'
  },
  controller: function () {
    function AppComponent($mdDialog, $mdMedia, $mdSidenav, $state, $scope, AuthService, FeedbackService, ToastService) {
      'ngInject';

      _classCallCheck(this, AppComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $mdMedia: $mdMedia,
        $mdSidenav: $mdSidenav,
        $state: $state,
        $scope: $scope,
        AuthService: AuthService,
        FeedbackService: FeedbackService,
        ToastService: ToastService
      });
    }

    _createClass(AppComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.showHamburgerMenu = {
          value: !this.$mdMedia('gt-md')
        };
      }
    }, {
      key: 'logout',
      value: function logout() {
        var _this = this;

        return this.authService.logout().then(function () {
          return _this.$state.go('login');
        });
      }
    }, {
      key: 'addFeedback',
      value: function addFeedback() {
        var _this2 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          onFeedbackSubmitted: function onFeedbackSubmitted($event) {
            return _this2.onFeedbackSubmitted($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          scope: scope,
          fullscreen: true,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <feedback\n                on-feedback-submitted="onFeedbackSubmitted($event)">\n              </feedback>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onFeedbackSubmitted',
      value: function onFeedbackSubmitted($event) {
        var _this3 = this;

        if ($event && $event.feedback) {
          this.FeedbackService.submit($event.feedback).then(function () {
            _this3.$mdDialog.hide();
            _this3.ToastService.showSuccess('Feedback submitted successfully!');
          }).catch(function (error) {
            return _this3.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'toggleMenu',
      value: function toggleMenu() {
        this.$mdSidenav('left').toggle();
      }
    }]);

    return AppComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/app.component.js